import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from 'jquery';
import { get } from "lodash";
import { Link } from "react-router-dom";
import { ACTION_CONST, ROUTES, STATUS } from "../../constants";
import { EXPLORER , MODE} from "../../_configs";
import { helpers } from "../../utils";
import { useTranslation } from "react-i18next";

const WithDrawTab = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [withdrawCurrentStep, setWithdrawCurrentStep] = useState(1);
    const isConnectWallet = useSelector((state) => get(state, "utils.isConnectWallet", false));
    const walletUtils = useSelector((state) => get(state, "utils.walletUtils", null));
    const walletAddress = useSelector((state) => get(state, "utils.walletAddress", ""));
    const stakingInfo = useSelector((state) => get(state, "wallet.stakingInfo", {}));
    const stakingWalletInfo = useSelector((state) => get(state, "wallet.stakingWalletInfo", {}));
    const trxBalance = useSelector((state) => get(state, "wallet.trxBalance", 0));
    const [acceptTerm, setAcceptTerm] = useState(false);
    const [enableWithDrawBtn, setEnableWithDrawBBtn] = useState(false);
    const [transactionHash, setTransactionHash] = useState("");
  

    const [isSubmitOK, setIsSubmitOK] = useState(false);


    /* WITHDRAW */
    useEffect(() => {
        setWithdrawStepActive();
    }, [setWithdrawStepActive, withdrawCurrentStep])


    //enable withdraw button
    useEffect(() => {
        if (acceptTerm && isConnectWallet && trxBalance > 0 && !stakingInfo["isStakingPaused"] && stakingWalletInfo["withdrawTimestamp"] > 0 && stakingWalletInfo["withdrawTimestamp"] <= (new Date().getTime())) {
            setEnableWithDrawBBtn(true);
        } else {
            setEnableWithDrawBBtn(false);
        }
    }, [acceptTerm, isConnectWallet, trxBalance, stakingInfo, stakingWalletInfo])


    const withdrawBack = () => {
        if (withdrawCurrentStep == 1) {
            return;
        } else {
            setWithdrawCurrentStep(withdrawCurrentStep - 1);
        }
    }

    const withdrawNext = () => {

        if (withdrawCurrentStep === 2) {
            if (walletUtils) {
                dispatch({
                    type: ACTION_CONST.REQUEST_SUBMIT
                })
                walletUtils.stakingExecuteWithdrawal(data => {
                    if (data.status === STATUS.STAKING_EXECUTE_WITHDRAWAL_SUCCESS) {
                        dispatch({
                            type: ACTION_CONST.REQUEST_DONE
                        })
                        setIsSubmitOK(true)
                        setTransactionHash(data.txID)
                        setWithdrawCurrentStep(3);
                    }
                    if(data.status === STATUS.STAKING_EXECUTE_WITHDRAWAL_FAIL){
                        dispatch({
                            type: ACTION_CONST.REQUEST_DONE
                        })

                        dispatch({
                            type: ACTION_CONST.ALERT_FAILS,
                            message:t('Withdraw stake fail')
                        })
                    }
                })
            }
        } else {
            if (withdrawCurrentStep == 3) {
                return;
            } else {
                setWithdrawCurrentStep(withdrawCurrentStep + 1);
            }
        }
    }


    const submitDone = () => {
        setWithdrawCurrentStep(1);
        setIsSubmitOK(false);
    }


    function setWithdrawStepActive() {
        $('#withdraw .bs-stepper-header .step').removeClass('active');
        $('#withdraw .bs-stepper-header .line').removeClass('active');
        for (var i = 1; i <= 3; i++) {
            if (i <= withdrawCurrentStep) {
                $('#withdraw #withdrawButtonStep' + i).addClass('active');
                $('#withdraw #withdrawLineStep' + (i - 1)).addClass('active');
            }
        }
        $('#withdraw .bs-stepper-content').hide();
        $('#withdraw #WithdrawStep' + withdrawCurrentStep).show();
    }

    return (

        <div className="tab-pane fade" id="withdraw" role="tabpanel" aria-labelledby="withdraw-tab">
            <div className="mt-3 mb-4 d-flex justify-content-center align-items-center">
                <h3 className="p-tab-title mb-0">{t('Withdraw your TRONPAD')}</h3>
            </div>
            <div className="row justify-content-center mb-4">
                <div className="col-lg-6">
                    <div className="bs-stepper w-100">
                        <div className="bs-stepper-header" role="tablist">
                            {/* your steps here */}
                            <div className="step active" id="withdrawButtonStep1">
                                <button type="button" className="step-trigger">
                                    <span className="bs-stepper-circle"><i className="mdi mdi-format-list-checkbox" /></span>
                                    <span className="bs-stepper-label">{t('Checkpoints')}</span>
                                </button>
                            </div>
                            <div className="line" id="withdrawLineStep1" />
                            <div className="step" id="withdrawButtonStep2">
                                <button type="button" className="step-trigger">
                                    <span className="bs-stepper-circle"><i className="mdi mdi-currency-usd" /></span>
                                    <span className="bs-stepper-label">{t('Initialize Withdrawal')}</span>
                                </button>
                            </div>
                            <div className="line" id="withdrawLineStep2" />
                            <div className="step" id="withdrawButtonStep3">
                                <button type="button" className="step-trigger">
                                    <span className="bs-stepper-circle"><i className="mdi mdi-check" /></span>
                                    <span className="bs-stepper-label">{t('Confirmation')}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-center">
                <div className="col-lg-12">
                    <div className="p-sidebar-card p-sidebar-card-steps">
                        <div className="p-sidebar-card-body">
                            <div className="bs-stepper-content" id="WithdrawStep1">
                                <div className="text-center">
                                    <h4>{t('Checkpoints')}</h4>
                                    <p>{t('The following conditions must be met to proceed:')}</p>
                                </div>
                                <div className="row mt-4 d-flex justify-content-center">
                                    <div className="col-lg-3 col-md-6 mb-lg-0 mb-3">
                                        <div className={isConnectWallet ? "p-select-card mb-4 selected" : "p-select-card mb-4"}>
                                            <div className="p-select-card-title"><b>{t('Connected with TronLink')}</b></div>
                                            <div className="p-select-card-description">{t('If not connected, click the "Connect Wallet" button in the top right corner')}</div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-lg-0 mb-3">
                                        <div className={stakingWalletInfo["withdrawTimestamp"] > 0 && stakingWalletInfo["withdrawTimestamp"] <= (new Date().getTime()) ? "p-select-card mb-4 selected" : "p-select-card mb-4"}>
                                            <div className="p-select-card-title"><b>{t('7 day waiting period elapsed')}</b></div>
                                            <div className="p-select-card-description"></div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-lg-0 mb-3">
                                        <div className={trxBalance > 0 ? "p-select-card mb-4 selected" : "p-select-card mb-4"}>
                                            <div className="p-select-card-title"><b>{t('TRX available in wallet')}</b></div>
                                            <div className="p-select-card-description">
                                                {t('TRX is required to pay transaction fees on the Tron network.')}<br />
                                                {t('TRX Balance:')} {helpers.formatNumberDownRoundWithExtractMax(trxBalance, 4)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-6 mb-lg-0 mb-3">
                                        <div className={stakingWalletInfo["withdrawTimestamp"] > 0 ? "p-select-card mb-4 selected" : "p-select-card mb-4"}>
                                            <div className="p-select-card-title"><b>{t('You have Unstaked your TRONPAD')}</b></div>
                                            <div className="p-select-card-description"></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4 text-center">
                                    <div className="form-check">
                                        <input className="form-check-input float-none me-1"

                                            type="checkbox" defaultValue id="flexCheckDefault"
                                            onChange={() => setAcceptTerm(!acceptTerm)} />
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            {t('I have read the')}&nbsp;
                                            <Link className="text-danger" target="_blank" to={ROUTES.TERMS_OF_USE}> <span className="text-danger">{t('Terms and Conditions')}</span> </Link>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="bs-stepper-content" id="WithdrawStep2">
                                <div className="text-center">
                                    <h4>{t('Confirm Withdrawal')}</h4>
                                    <p>{t('In this step, you complete the transaction that withdraws your TRONPAD tokens')}</p>
                                </div>
                            </div>
                            <div className="bs-stepper-content" id="WithdrawStep3">
                                <div className="text-center">
                                    <div className="text-success">
                                        <i className="mdi mdi-check" style={{ fontSize: '50px' }} />
                                    </div>
                                    <h4>{t('Confirmed')}</h4>
                                    <p>
                                        {t('You have withdrawn your TRONPAD tokens.')}<br />
                                        {t('If desired, you may check Tron to confirm the transaction.')}
                                    </p>
                                    <p><a className="p-address" href={`${EXPLORER[MODE]}/transaction/${transactionHash}`} target="blank">{transactionHash}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mb-3 mt-4 text-center step-buttons">
                {!isSubmitOK ?
                    <>
                        <button onClick={() => withdrawBack()} type="button" disabled={!enableWithDrawBtn || withdrawCurrentStep === 1} className="btn btn-primary btn-round btn-back-step me-3 px-5"><i className="mdi mdi-arrow-left me-2" /><span>{t('Previous')}</span></button>
                        <button onClick={() => withdrawNext()} type="button" disabled={!enableWithDrawBtn || withdrawCurrentStep === 3} className="btn btn-primary btn-round btn-next-step px-5"><span>{t('Next')}</span><i className="mdi mdi-arrow-right ms-2" /></button>
                    </>
                    :
                    <>
                        <button onClick={() => submitDone()} type="button" className="btn btn-primary btn-round  me-3 px-5"><span>{t('Done')}</span></button>
                    </>
                }

            </div>
        </div>


    );
};

export default WithDrawTab;
